<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-01 18:09:40
-->
<template>
    <div class="add-danwei">
        <el-form
            ref="ruleForm"
            :model="viewData"
            :rules="rules"
            label-width="100px"
        >
            <el-form-item label="栏目" prop="cate_id">
                <el-cascader
                    :value="viewData.cate_id"
                    :options="list"
                    :props="{
                        checkStrictly: true,
                        label: 'name',
                        value: 'id',
                    }"
                    clearable
                    @change="handleParentPermissionChange"
                ></el-cascader>
            </el-form-item>
            <el-form-item label="文章标题" prop="title">
                <el-input v-model="viewData.title" />
            </el-form-item>
            <el-form-item label="关键字">
                <el-input v-model="viewData.keywords" />
            </el-form-item>
            <el-form-item label="封面图">
                <image-upload ref="imageUpload" v-if="showUpload" :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸100*100,请自己处理好宽高比例`" :image-list="imageDefaultList" @updateImg="onUpdateImg($event)"></image-upload>
            </el-form-item>
            <el-form-item label="描述">
                <el-input v-model="viewData.describe" />
            </el-form-item>
            <el-form-item label="栏目内容">
                <tinymce ref="tinymce" v-model="viewData.content" :height="300" />
            </el-form-item>
            <el-form-item label="是否推荐">
                <el-switch
                    v-model="viewData.push_flag"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
            <el-form-item label="来源">
                <el-input v-model="viewData.source" />
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number
                    size="mini"
                    style="width: 100px"
                    v-model="viewData.sort"
                    controls-position="right"
                    :min="0"
                ></el-input-number>
            </el-form-item>
            <el-form-item label="状态">
                <el-switch
                    v-model="viewData.status"
                    class="drawer-switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                />
            </el-form-item>
            <el-form-item label="发布时间">
                <el-date-picker
                    v-model="viewData.publish_at"
                    type="datetime"
                    value-format="yyyy-MM-dd hh:mm:ss"
                    placeholder="发布时间"
                >
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div class="fix-fotter">
            <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;" size="mini" type="primary" @click="tijiao('ruleForm')">提交</el-button>
        </div>
    </div>
</template>

<script>
import fetch from "@/api/console/Article";
import Cate from "@/api/console/Cate";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
import ImageUpload from '@/components/Upload/image'
import Tinymce from '@/components/Tinymce'
export default {
    data() {
        return {
            showUpload:false,
            // 图片上传组件默认图片
            imageDefaultList:'',
            thumbList: [], // 图片暂存
            list:[],
            viewData: {
                id: "",
                cate_id: "",
                title: "",
                keywords: "",
                thumb: "",
                describe: "",
                content: "",
                push_flag: 1,
                source: "",
                address: "",
                sort: 0,
                status: 1,
                publish_at: '',
            },
            rules: {
                cate_id: [
                    {
                        required: true,
                        message: "请选择栏目",
                        trigger: "change",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "请输入文章标题",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    components: {
        Pagination,
        ImageUpload,
        Tinymce
    },
    created() {
    },
    methods: {
        /**
		 * @name: 图片更新
		 * @param {*} val
		 * @return {*}
		 * @desc: 
		 */		
		onUpdateImg(val){
			let thumbList = [];
			val.forEach((ele, idx) => {
                thumbList.push({
					url:ele.path,
					filetype:ele.filetype
				})
            });
			this.thumbList = thumbList;
			// console.log('图片更新==',this.thumbList);
		},
        localPermissionTree(tree) {
            tree.forEach((permissionItem) => {
                permissionItem.name = this.$te("route." + permissionItem.name)
                    ? this.$t("route." + permissionItem.name, "zh")
                    : permissionItem.name;
                if (
                    permissionItem.children &&
                    permissionItem.children.length > 0
                ) {
                    this.localPermissionTree(permissionItem.children);
                }
            });
            return tree;
        },
        handleParentPermissionChange(value) {
            if (value.length === 0) {
                this.viewData.cate_id = 0;
            } else {
                this.viewData.cate_id = value[value.length - 1];
            }
        },
        // 获取父级栏目
        getList() {
            let that = this;
            this.listLoading = true;
            Cate.list({}).then((res) => {
                that.listLoading = false;
                that.list = this.localPermissionTree(res.result);
            });
        },
        /**
         * @name: 初始化列表
         * @param {*} obj
         * @return {*}
         * @desc:
         */
        initFun(obj) {
            $(".el-drawer__body").scrollTop(0)
            let that = this
            this.viewData = {
                id: "",
                cate_id: "",
                title: "",
                keywords: "",
                thumb: "",
                describe: "",
                content: "",
                push_flag: 1,
                source: "",
                address: "",
                sort: 0,
                status: 1,
                publish_at: '',
            }
            this.imageDefaultList = ''
            this.thumbList = []
            this.showUpload = true
            this.getList()
            if (obj.id) {
                // 编辑
                this.viewData.id = obj.id;
                fetch.detail({ id: obj.id }).then((res) => {
                    console.log(res)
                    if (res.code == 200) {
                        that.viewData = res.result
                        that.viewData.id = res.result.id;

                        if (that.viewData.content) {
                            that.$nextTick(function () {
                                that.$refs.tinymce.setContent(that.viewData.content)
                            });
                        }
                        
                        if(that.viewData.thumb) {
                            let imgList = []
                            let obj = {
								name: that.viewData.thumb,
								path:that.viewData.thumb,
								url: this.$publicData.imgUrl + that.viewData.thumb,
							}
							imgList.push(obj);
                            // 案件带的 回显图
                            that.imageDefaultList = JSON.stringify(imgList);
                        }
                    }
                });
            } else {
                // 新增
            }
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc: 
         */		
         tijiao(formName) {
            let that = this
            this.viewData.thumb = this.thumbList[0] ? this.thumbList[0].url : ''
            console.log(this.viewData)
            this.$refs[formName].validate(valid => {
                if (valid) {
					if(this.viewData.id){
						// 编辑
						fetch.edit(this.viewData).then(res=>{
                            that.resetForm()
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						})
					}else{
						// 新增
						fetch.create(this.viewData).then(res=>{
                            that.resetForm()
							if(res.code == 200){
								that.$message.success(res.message);
								that.$emit('onUpdateDrawer', 1)
							}else{
								that.$message.error(res.message);
								that.$emit('onUpdateDrawer', -1)
							}
						}) 
					}
                      
                } else {
                    // this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 清空form
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.$refs.tinymce.setContent('')
            this.showUpload = false
            this.imageDefaultList = ''
            this.thumbList = []
            this.$refs["ruleForm"].resetFields();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
